import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './views/layout/App.vue'
import 'vuetify/dist/vuetify.min.css'
import './assets/sass/base.scss'

import router from './router'
import store from './store'
import './components'

Vue.config.productionTip = false

Vue.use(Vuetify, {
    options: {
        customProperties: true,
    },
    theme: {
        accent: store.getters.accentColor,
        primary: store.getters.backgroundColor,
        danger: '#FF5252',
        // primary: colors.red.darken1, // #E53935
        // secondary: colors.red.lighten4, // #FFCDD2
        // accent: colors.indigo.base // #3F51B5
    },
})
// Vue.use(Vuetify, {
//     theme: {
//         primary: '#f50057',
//         secondary: '#424242',
//         contrast: '#553faf',
//         'light-contrast': '#dfdcee',
//         grey: '#999999',
//         accent: '#82B1FF',
//         error: '#FF5252',
//         danger: '#FF5252',
//         info: '#2196F3',
//         success: '#4CAF50',
//         warning: '#FFC107',
//         // star: colors.yellow.darken2
//     },
// })

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
